"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeSessionDataLoaderBase = void 0;
var AlmeSessionDataUtils_1 = require("./AlmeSessionDataUtils");
var AlmeSessionDataLoaderBase = /** @class */ (function () {
    function AlmeSessionDataLoaderBase(storageLoader, logger) {
        this.storageLoader = storageLoader;
        this.logger = logger;
    }
    /**
     * Clears saved Alme session data.
     */
    AlmeSessionDataLoaderBase.prototype.ClearAlmeSessionData = function () {
        this.storageLoader.ClearStorage();
    };
    /**
     * Returns saved Alme session data.
     *
     * @throws SecurityError if storage method is disabled or does not exist.
     */
    AlmeSessionDataLoaderBase.prototype.GetAlmeSessionData = function () {
        var storedAlmeSession = this.storageLoader.GetStorage();
        if (storedAlmeSession) {
            return storedAlmeSession;
        }
        else {
            var almeSession = AlmeSessionDataUtils_1.AlmeSessionDataUtils.CreateAlmeSessionData();
            return this.storageLoader.UpdateStorage(almeSession);
        }
    };
    /**
     * Updates saved Alme session data
     *
     * @throws SecurityError if storage method is disabled or does not exist.
     *
     * @throws Set storage exceptions if storage method is disabled or does not exist.
     */
    AlmeSessionDataLoaderBase.prototype.UpdateAlmeSessionData = function (data) {
        if (data && data.sessionId && data.userId && data.lastActivityTime !== undefined) {
            return this.storageLoader.UpdateStorage(data);
        }
        return this.storageLoader.GetStorage();
    };
    return AlmeSessionDataLoaderBase;
}());
exports.AlmeSessionDataLoaderBase = AlmeSessionDataLoaderBase;
//# sourceMappingURL=AlmeSessionDataLoaderBase.js.map